import { Avatar, AvatarProps } from 'antd'
import React from 'react'
import { User } from '../user'

export type UserAvatarProps = {
    user: Pick<User, 'avatar'>
}

export function UserAvatar({ user, ...rest }: UserAvatarProps & AvatarProps) {
    return (
        <Avatar
            src={user.avatar}
            {...rest}
        />
    )
}
